<!-- eslint-disable @angular-eslint/template/alt-text -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!--

    TODO:
    1. Add module & rewire
    2. Replace with mat-list & (mat-list-item for rx-list-item)
    3. Move rx-list-item into this module
    4. ...

-->
<div *ngIf="!insideVisibleArea" class="rel" style="height: 60px; width: 100%">
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    xml:space="preserve"
    style="position: absolute; left: 0; top: 0; width: 100%; height: 100%"
  >
    <g x="50">
      <rect x="15" y="15" rx="3" ry="3" width="28" height="30" fill="#e4eef7" stroke-width="0" />
      <rect x="60" y="15" rx="5" ry="5" width="25%" height="11" fill="#e4eef7" stroke-width="0" />
      <rect x="60" y="35" rx="5" ry="5" width="50%" height="11" fill="#e4eef7" stroke-width="0" />
    </g>
  </svg>
</div>
<div class="toolbar" *ngIf="insideVisibleArea">
  <!-- Conditional Checkbox  -->
  <!-- TODO: Ensure RxPhoto Form works before introducing hide condition -->

  <div class="prefix-content">
    <mat-checkbox [(ngModel)]="checked" (ngModelChange)="onCheckedChange()" *ngIf="checkbox"></mat-checkbox>
    <!-- *ngIf="checkbox" -->
    <rx-icon name="icon-spinner" class="spinner hidden"></rx-icon>
  </div>
  <div class="content">
    <!-- Leading Image or Icon -->

    <ng-container
      *ngIf="icon || image"
      [ngTemplateOutlet]="icon ? iconTemplate : imageTemplate"
      [ngTemplateOutletContext]="{ item: data }"
    ></ng-container>

    <!-- Title & Descriptions  -->
    <!-- TODO: Refactor this. (Single/Double/Tripple line content can be used)  -->

    <div [id]="id + '-toggle'" class="content-text cp" (click)="toggleChecked()">
      <div>
        <div class="title-container">
          <div [id]="id + '-title'" class="top" [class.top-selected]="checked || selected">{{ title }}</div>
          @if (indicator) {
            <ng-container [ngTemplateOutlet]="indicator" [ngTemplateOutletContext]="{ selected }" />
          }
        </div>
        <div
          [id]="id + '-subtitle'"
          class="bottom"
          *ngIf="getHtml(description) as htmlData"
          [innerHTML]="htmlData"
        ></div>
      </div>
    </div>

    <!-- Far right controls -->
    <div
      [id]="id + '-right-controls'"
      [rxRoleGuard]="rejectedRoles"
      class="action-controls flex flex-row flex-nosize"
      *ngIf="trailingText || showDragHandle || showMenuHandle || showIconCheck || showControls || showEditHandle"
    >
      <span class="trailing-text" *ngIf="trailingText">{{ trailingText }}</span>
      <div [id]="id + '-preview'" class="preview-btn" (click)="onPreview(data)" *ngIf="showPreviewHandle">Preview</div>
      <rx-icon
        [id]="id + '-edit'"
        name="icon-edit"
        *ngIf="showEditHandle"
        class="rel z1 blue text-large"
        [class.disabled]="disableEdit"
        (click)="onEditClicked($event)"
      ></rx-icon>
      <ng-content select="[controls]"></ng-content>
      <rx-icon
        [id]="id + '-drag'"
        name="icon-drag"
        *ngIf="showDragHandle"
        (mouseenter)="onEnableDrag(true)"
        (mouseleave)="onEnableDrag(false)"
        class="rel z1"
        cdkDragHandle
      ></rx-icon>
      <rx-icon
        *ngIf="showMenuHandle"
        [id]="id + '-show-menu'"
        name="icon-ellipses"
        class="rel z1"
        [class.disabled]="disableMenu"
        [matMenuTriggerFor]="actionMenu"
        [matMenuTriggerData]="actionMenuContext"
        (click)="onMenuClicked($event)"
      ></rx-icon>

      <!-- TODO: need change color -->
      <rx-icon [id]="id + '-icon'" *ngIf="showIconCheck" name="icon-check"></rx-icon>
    </div>
  </div>
</div>

<!-- Image, otherwise default Icon template-->
<ng-template #imageTemplate>
  <!-- TODO: extend rx-icon to accept images -->
  <rx-icon [id]="id + '-thumb-icon'" name="icon-square" *ngIf="icon"></rx-icon>
  <img
    [id]="id + '-img'"
    [src]="image"
    *ngIf="image"
    [class]="avatarType + '-avatar'"
    [class.img-selected]="checked || selected"
  />
</ng-template>

<!-- Icon only template-->
<ng-template #iconTemplate let-item="item">
  <rx-icon
    *ngIf="icon"
    [id]="id + '-thumb'"
    [class.icon-selected]="checked || selected"
    [name]="icon"
    (click)="onThumbClicked(item)"
  ></rx-icon>
</ng-template>
